import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import router from '@/router';

import autentikasi from '@/store/vo-general/autentikasi'
import opsi from '@/store/vo-general/opsi'
import jaringan from '@/store/vo-general/jaringan'
import produk from '@/store/vo-general/produk'
import transaksiProduk from '@/store/vo-general/transaksiProduk'
import repeatOrder from '@/store/vo-general/repeatOrder'
import profil from '@/store/vo-general/profil'
import komisi from '@/store/vo-general/komisi'
import dashboard from '@/store/vo-general/dashboard'
import testimony from '@/store/vo-general/testimony'
import reward from '@/store/vo-general/reward'
import pesan from '@/store/vo-general/pesan'

import {
	PAGE_TITLE
} from './mutation-types';

export default new Vuex.Store({
	state: {
		pageTitle: "MLM Core VO",
		errorAlert : {
			show: false,
			color: 'red',
			alert: []
		},
		alert: {
			show: false
		},
		loading: false,
		snackbar: {
			show: false,
			color: 'green accent-4',
			text: ''
		},
		successResponse: {},
		errorMessage: '',
		errorValidation: {},
	},
	mutations: {
		[PAGE_TITLE](state, title) {
			state.pageTitle = title;
		},
		makeAlert(state, data) {
			if (data.code != 406) {
				state.alert = data
			}
		},
		progress(state, data) {
			state.loading = data
		},
		setErrorAlert(state, data) {
			state.errorAlert = data
			state.snackbar.show = false
		},
		hideAlert(state) {
			state.errorAlert.show = false
		},
		setSnackbar(state, data) {
			state.snackbar = data
			state.errorAlert.show = false
		},
		hideSnackbar(state) {
			state.snackbar.show = false
		},
		setSuccessResponse(state, data) {
			state.successResponse = data.results
		},
		setErrorMessage(state, data) {
			state.errorMessage = data
		},
		emptyErrorMessage(state) {
			state.errorMessage = ''
		},
		setErrorValidation(state, data) {
			state.errorValidation = data
		},
		emptyErrorValidation(state) {
			state.errorValidation = {}
		},
	},
	actions: {
		setPageTitle({ commit }, title) {
			commit(PAGE_TITLE, title);
		},
		success({ commit }, response) {
			commit('setSuccessResponse', response.data)
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: response.message
			});
		},
		errorHandler({ commit }, response) {
			if (response.code == 500) {
				commit('setSnackbar', {
					show: true,
					color: 'warning',
					text: response.message
				});
			} else {
				switch (response.error) {
					case 'validation':
					commit('setErrorValidation', response.data)
					commit('setSnackbar', {
						show: true,
						color: 'warning',
						text: response.message
					});
					break;
					
					case 'process':
						commit('setErrorMessage', response.message)
						commit('setSnackbar', {
							show: true,
							color: 'warning',
							text: response.message
						});
						break;
					
					case 'unauthorization':
					commit('setSnackbar', {
						show: true,
						color: 'warning',
						text: response.message
					});
					break;
					
					case 'maintenance':
					router.push({ path: '/maintenance' })
					break;

					default:
					commit('setSnackbar', {
						show: true,
						color: 'warning',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					});
					break;
				}
			}
		},
	},
	modules: {
		autentikasi,
		opsi,
		jaringan,
		produk,
		transaksiProduk,
		repeatOrder,
		profil,
		komisi,
		dashboard,
		testimony,
		reward,
		pesan
	}
});
